/* tslint:disable */

/**
 */
export class ViewChaining_parent {
    id?: number;
    name?: string;
    equipName?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-chaining-_parent.ts